import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            关于51吃瓜网
          </h2>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {aboutData.content}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {aboutData.highlights.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-2 p-3 rounded-lg bg-background-100"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${i === 0 ? 'ri-flashlight-line' : i === 1 ? 'ri-user-star-line' : i === 2 ? 'ri-heart-line' : 'ri-shield-check-line'} text-lg`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800 text-center">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}